import { render, staticRenderFns } from "./Categorydetail.vue?vue&type=template&id=1400d418&"
import script from "./Categorydetail.vue?vue&type=script&lang=js&"
export * from "./Categorydetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports